var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":_vm.iframeUTM,"frameborder":"0","allowfullscreen":"allowfullscreen","webkitallowfullscreen":"","mozallowfullscreen":"","oallowfullscreen":"","msallowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }